<script type="text/javascript">
  export default {
    data() {
      return {
        
      }
    },
    props: {
      selection: {
        type: [Object, Array],
        default () {
          return {}
        }
      }
    },
  }
</script>